import { type ReactNode } from 'react'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: ReactNode
}

export default function Modal({ isOpen, onClose, title, children }: ModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div 
        className="bg-[var(--color-surface)] rounded-xl shadow-xl w-full max-w-md mx-4"
        onClick={(e) => e.target !== e.currentTarget && onClose()}
      >
        <div className="flex items-center justify-between p-4 border-b border-[var(--color-border)]">
          <h3 className="text-lg font-semibold text-[var(--color-text)]">{title}</h3>
          <button
            onClick={onClose}
            className="rounded-full p-1 hover:bg-[var(--color-surface-subtle)] transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[var(--color-text-muted)]" viewBox="0 0 24 24" fill="currentColor">
              <path fillRule="evenodd" d="M18 12a.75.75 0 01-.75.75H12v4.75a.75.75 0 01-1.5 0V12.75H4.75a.75.75 0 010-1.5h4.75V6.25a.75.75 0 011.5 0v4.75h4.75a.75.75 0 01.75.75z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
        <div className="p-4">
          {children}
        </div>
      </div>
    </div>
  )
}
